import crossFetch from 'cross-fetch';
import fetchRetry from 'fetch-retry';
import { isHydrated } from '../../utils/utils';

const APPLE_PAY_FETCH_RETRY_CONFIG: Parameters<typeof fetchRetry>[1] = {
    retries: 3,
    retryOn: [403, 429, 502, 503, 504, 505, 506, 507, 508, 509, 510, 511],
    retryDelay: (attempt: number) => 2 ** attempt * 600, // 600, 1200, 2400
};

const fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> =>
    isHydrated() && typeof window.fetch === 'function'
        ? window.pwaAuthFlowPromise.then(() =>
              fetchRetry(window.fetch, APPLE_PAY_FETCH_RETRY_CONFIG)(input, init),
          )
        : fetchRetry(crossFetch, APPLE_PAY_FETCH_RETRY_CONFIG)(input, init);

const handleFetchJSONResponse = <ResponseType>(response: Response): PromiseLike<ResponseType> =>
    response.json().then((json: ResponseType) => json);

export const postJson = <RequestType, ResponseType>(
    url: string,
    data: RequestType,
): Promise<ResponseType> => {
    const json: BodyInit | null = JSON.stringify(data);
    return window.pwaAuthFlowPromise.then(() =>
        fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: json,
        }).then(
            (response: Response): PromiseLike<ResponseType> => handleFetchJSONResponse(response),
        ),
    );
};
